import { ColorSwatch } from '@swivl-mono/ui';
import "./BrandColorRow.scss";

interface Props {
  label: string;
  color: string;
  name: string;
  onColorChange: (name: string, color?: string) => void;
}

export function BrandColorRow(props: Props) {
  const { onColorChange, name, color, label } = props;

  return (
    <div className="BrandColorRow flex flex-row items-center justify-center mb-2">
      <ColorSwatch
        color={color}
        name={name}
        onColorChange={onColorChange} />
      <div className="flex-1 ml-2 mb-0 flex flex-row items-center justify-start "><label className="m-0 p-0 brand label">{label}</label></div>
    </div>
  );
}
